import { render } from "./Page7.vue?vue&type=template&id=2ebb00a1"
import script from "./Page7.vue?vue&type=script&lang=js"
export * from "./Page7.vue?vue&type=script&lang=js"

import "./Page7.vue?vue&type=style&index=0&id=2ebb00a1&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__